export default __webpack_public_path__ + "static/media/client_message_sound.de8a81e0.mp3";